import { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@shadcn/components/ui/dialog';
import { Button } from '@shadcn/components/ui/button';
import { Input } from '@shadcn/components/ui/input';
import { Label } from '@shadcn/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@shadcn/components/ui/select';
import { createAmazonConfig } from '../AmazonSellerConfig.service';
import { toast } from 'react-toastify';

export function AddAmazonConfigDialog({ open, onOpenChange, onSuccess }) {
  const [formData, setFormData] = useState({
    storeKey: '',
    region: '',
    refreshToken: '',
    clientId: '',
    clientSecret: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const newConfig = await createAmazonConfig(formData);
      toast.success('Amazon Seller Config created successfully');
      onSuccess(newConfig);
      setFormData({
        storeKey: '',
        region: '',
        refreshToken: '',
        clientId: '',
        clientSecret: '',
      });
    } catch (error) {
      console.error('Failed to create amazon config:', error);
      toast.error(error.response?.body?.message || 'Failed to create Amazon Seller Config');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <i className="bx bxl-amazon text-orange-500 text-xl"></i>
            Add Amazon Seller Config
          </DialogTitle>
        </DialogHeader>
        <form onSubmit={handleSubmit}>
          <div className="grid gap-4 py-4">
            <div className="grid grid-cols-4 items-center gap-4">
              <Label htmlFor="storeKey" className="text-left">
                Store Key
              </Label>
              <Input
                id="storeKey"
                value={formData.storeKey}
                onChange={(e) => handleChange('storeKey', e.target.value)}
                className="col-span-3"
                placeholder="amazon-us"
                required
              />
            </div>
            <div className="grid grid-cols-4 items-center gap-4">
              <Label htmlFor="region" className="text-left">
                Region
              </Label>
              <Select
                value={formData.region}
                onValueChange={(value) => handleChange('region', value)}
                required
              >
                <SelectTrigger className="col-span-3">
                  <SelectValue placeholder="Select region" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="na">North America</SelectItem>
                  <SelectItem value="eu">Europe</SelectItem>
                  <SelectItem value="fe">Far East</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <div className="grid grid-cols-4 items-center gap-4">
              <Label htmlFor="clientId" className="text-left">
                Client ID
              </Label>
              <Input
                id="clientId"
                value={formData.clientId}
                onChange={(e) => handleChange('clientId', e.target.value)}
                className="col-span-3"
                placeholder="Amazon Client ID"
                required
              />
            </div>
            <div className="grid grid-cols-4 items-center gap-4">
              <Label htmlFor="clientSecret" className="text-left">
                Client Secret
              </Label>
              <Input
                id="clientSecret"
                type="password"
                value={formData.clientSecret}
                onChange={(e) => handleChange('clientSecret', e.target.value)}
                className="col-span-3"
                placeholder="Amazon Client Secret"
                required
              />
            </div>
            <div className="grid grid-cols-4 items-center gap-4">
              <Label htmlFor="refreshToken" className="text-left">
                Refresh Token
              </Label>
              <Input
                id="refreshToken"
                type="password"
                value={formData.refreshToken}
                onChange={(e) => handleChange('refreshToken', e.target.value)}
                className="col-span-3"
                placeholder="Amazon Refresh Token"
                required
              />
            </div>
          </div>
          <DialogFooter>
            <Button 
              type="button" 
              variant="outline" 
              onClick={() => onOpenChange(false)}
              disabled={isSubmitting}
            >
              Cancel
            </Button>
            <Button type="submit" disabled={isSubmitting}>
              {isSubmitting ? 'Creating...' : 'Create'}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}